module.exports = __webpack_public_path__ + "img/navbar.3c5b5ca.png";